import React, { useEffect, useState } from "react";
import LRSelectModal from "../components/LRSelectModal";
import SectionHeader from "../components/SectionHeader";
import { getDocketEntries } from "../services/docketEntryService";
import { createManifest } from "../services/manifestService";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ManifestForm from "../components/ManifestForm";
import { Save } from "lucide-react";

const Manifestation = () => {
  const [manifest, setManifest] = useState({
    dispatchDate: "",
    dispatchTime: "",
    manifestNo: "",
    destination: "",
    vehicleNo: "",
    branchID: "",
    totalConsignments: 0,
    totalPackages: 0,
    totalWeight: 0,

    shipments: [],

    driverName: "",
    loadingMaster: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((state) => state.user);
  /* ------------------ UI ------------------ */
  const handleSaveManifest = async () => {
    try {
      const now = new Date();

      if (!user?.branch?.id && !user?.branch?.code) {
        toast.error("User branch information is missing.");
        return;
      }
      if (!manifest?.manifestNo || !manifest?.destination) {
        toast.error("Manifest Number and Destination are required.");
        return;
      }
      setIsLoading(true);
      const payload = {
        ...manifest,
        branchID: user?.branch?.id,
        branchCode: user?.branch?.code,
        dispatchDate: now.toISOString().split("T")[0],
        dispatchTime: now.toTimeString().split(" ")[0],
        shipments: manifest?.shipments?.map((s) => ({
          ...s,
          boxes: Number(s.boxes) || 0,
          weight: Number(s.weight) || 0,
        })),
      };

      const res = await createManifest(payload);
      if (res?.status === 200 || res?.status === 201) {
        // alert("Manifest saved successfully!");
        toast.success("Manifest saved successfully!");
        handleClear();
        console.log("Manifest saved:");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error);
      console.error("Error saving manifest:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleClear = () => {
    setManifest({
      dispatchDate: "",
      dispatchTime: "",
      manifestNo: "",
      destination: "",
      vehicleNo: "",
      branchID: "",
      totalConsignments: 0,
      totalPackages: 0,
      totalWeight: 0,

      shipments: [],

      driverName: "",
      loadingMaster: "",
    });
  };
  return (
    <div className="bg-slate-200 min-h-screen p-4">
      <div className=" space-y-4">
        <SectionHeader
          title="Manifestation"
          subTitle="Create and manage shipment manifests"
        />

        {/* Manifest Info */}
        <ManifestForm
          manifest={manifest}
          setManifest={setManifest}
          handleSaveManifest={handleSaveManifest}
          handleClear={handleClear}
        />

        {/* Actions */}
        <div className="flex justify-end gap-4 mt-6">
          <button
            onClick={handleSaveManifest}
            className="flex gap-2 items-center px-10  py-1 rounded border border-sky-600 text-sm bg-sky-500 text-white cursor-pointer hover:bg-sky-700"
          >
            <Save size={20} />
            <div className="text-sm">{isLoading ? "Loading..." : "Save"}</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Manifestation;
